import acts from './acts.reducer';
import affiliates from './affiliates.reducer';
import beacons from './beacons.reducer';
import categories from './categories.reducer';
import documents from './documents.reducer';
import emailTemplates from './email-templates.reducer';
import hyperwalletAccounts from './hyperwallet-accounts.reducer';
import hyperwalletLogs from './hyperwallet-logs.reducer';
import invitations from './invitations.reducer';
import links from './links.reducer';
import messages from './messages.reducer';
import notifications from './notifications.reducer';
import payouts from './payouts.reducer';
import products from './products.reducer';
import profiles from './profiles.reducer';
import requests from './requests.reducer';
import reviews from './reviews.reducer';
import shows from './shows.reducer';
import threads from './threads.reducer';
import tickets from './tickets.reducer';
import typingStates from './typing-states.reducer';
import users from './users.reducer';
import venues from './venues.reducer';

export default {
  acts,
  affiliates,
  beacons,
  categories,
  documents,
  emailTemplates,
  hyperwalletAccounts,
  hyperwalletLogs,
  invitations,
  links,
  messages,
  notifications,
  payouts,
  products,
  profiles,
  requests,
  reviews,
  shows,
  threads,
  tickets,
  typingStates,
  users,
  venues,
};
